import React from 'react'
import PropTypes from 'prop-types'
import * as S from './style'

const SeeInstallment = ({ link }) => {
  return (
    <S.SeeInstallmentContainer id="valorVerParcelas">
      <S.SeeInstallmentLink
        href={`${link}&lkid=1446&/#VerParcelasCardRB`}
        id="link_card"
        target="_blank"
      >
        Ver parcelas
      </S.SeeInstallmentLink>
    </S.SeeInstallmentContainer>
  )
}

SeeInstallment.propTypes = {
  link: PropTypes.string.isRequired,
}

export default SeeInstallment
